import { forwardRef, useContext } from 'react'
import { ChipsContentContainer } from '../styled-components'
import { ChipsContext } from './chips-context'

const ChipsContent = forwardRef(({ children, ...props }, fowardedRef) => {
  const context = useContext(ChipsContext)

  return (
    <ChipsContentContainer ref={fowardedRef} {...props} {...context}>
      {children}
    </ChipsContentContainer>
  )
})

ChipsContent.displayName = 'ChipsContent'

export default ChipsContent
